<div class="daterange-wrapper">
  <mat-form-field appearance="outline" color="primary">
    <mat-label>{{ label }}</mat-label>

    <mat-date-range-input [formGroup]="range" [disabled]="range.disabled">
      <input
        class="h-9"
        matStartDate
        formControlName="fromDate"
        placeholder="YYYY-MM-DD"
      />
      <input
        class="h-9"
        matEndDate
        formControlName="toDate"
        placeholder="YYYY-MM-DD"
      />
    </mat-date-range-input>

    @if (showHint) {
      <mat-hint>YYYY-MM-DD - YYYY-MM-DD</mat-hint>
    }

    <button
      mat-icon-button
      matSuffix
      cdkOverlayOrigin
      #origin="cdkOverlayOrigin"
      type="button"
      (click)="togglePopup()"
      [disabled]="range.disabled"
      aria-label="Open date range picker"
    >
      <mat-icon>calendar_today</mat-icon>
    </button>
  </mat-form-field>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isPickerOpen"
    [cdkConnectedOverlayPanelClass]="'stena-range-overlay'"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayPositions]="overlayPositions"
    (backdropClick)="closePopup()"
    (detach)="closePopup()"
    (attach)="refreshCalendarClasses()"
  >
    <div [class]="popupClassName">
      @if (preDefinedDatesOptions.length > 0) {
        <mat-action-list class="left-panel">
          @for (dateOption of preDefinedDatesOptions; track dateOption.id) {
            <button
              mat-list-item
              type="button"
              (click)="selectPredefinedDate(dateOption.id)"
              [disabled]="range.disabled"
            >
              {{ dateOption.label }}
            </button>
          }
        </mat-action-list>
      }

      <div class="calendar-panel">
        <mat-calendar
          [selected]="calendarAnchorDate"
          [dateClass]="dateClass"
          (selectedChange)="onCalendarDateSelected($event)"
        ></mat-calendar>

        <div class="actions">
          <button mat-button type="button" (click)="clearRange()">Clear</button>
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="closePopup()"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</div>
